import React, { ReactElement, useEffect, useRef } from 'react';

import styles from './WidgetVideo.module.scss';
import { IVideoType } from "@common/redux/types/event";

interface IProp {
  widget: IVideoType,
  scrollToVideo?: boolean;
}

export const WidgetVideo = ({ widget, scrollToVideo }: IProp): ReactElement => {
  const { videoUrl } = widget;
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current && scrollToVideo) {
      window.onload = () => {
        setTimeout(() => {
          videoRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        });
      }
      setTimeout(() => {
        videoRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      });
    }
  }, [videoRef]);

  return (
    <>
      <iframe
        ref={videoRef}
        allowFullScreen
        className={styles.video}
        frameBorder="0"
        src={videoUrl}
        title="video"
      />
    </>
  );
};
